module.exports = __webpack_public_path__ + "static/purchasing_process2-004d2a10426a0c853b2847ebefbff7ee.png";